// extracted by mini-css-extract-plugin
module.exports = {"form":"pin_form__3REiY","testHugggText":"pin_testHugggText__39B2l"};